<div style="position: relative">
  <input
    [style.height]="height"
    type="text"
    class="form-control"
    placeholder="Buscar Paises"
    [formControl]="control"
    [matAutocomplete]="auto"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="selectCountry()"
  >
    <mat-option
      *ngFor="let country of filteredCountries | async"
      [value]="country"
    >
      <span>{{ country.nombre }}</span>
      <small> +{{ country.phone_code }}</small>
    </mat-option>
  </mat-autocomplete>
</div>
